import { api, authHeader } from "../configs/axiosConfigs";

const resolveBaseUrl = (source) =>
  source === "Management"
    ? "/SLN/Management/FulfillmentWorkQueue"
    : "/SLN/SolarentOperator/FulfillmentWorkQueue";

const post = async (source, action, data) => {
  const response = await api.request({
    url: `${resolveBaseUrl(source)}/${action}`,
    method: "POST",
    headers: authHeader(),
    data,
  });
  return response.data;
};

const getBlob = async (source, action, params) => {
  const query = new URLSearchParams(params).toString();
  return api.request({
    url: `${resolveBaseUrl(source)}/${action}?${query}`,
    method: "GET",
    responseType: "blob",
    headers: authHeader(),
  });
};

const FulfillmentWorkQueueApi = {
  search: (source = "SolarentOperator", searchParams = {}) =>
    post(source, "Search", searchParams),

  getProjectDetail: async (source = "SolarentOperator", requestId) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/GetProjectDetail`,
      method: "GET",
      params: { requestId },
      headers: authHeader(),
    });
    return response.data;
  },

  downloadWarehouseExitPdf: (source = "SolarentOperator", requestId) =>
    getBlob(source, "DownloadWarehouseExitPdf", { requestId }),

  downloadDeliveryNotePdf: (source = "SolarentOperator", requestId) =>
    getBlob(source, "DownloadDeliveryNotePdf", { requestId }),

  registerSupply: (source = "SolarentOperator", payload) =>
    post(source, "RegisterSupply", payload),

  registerShipment: (source = "SolarentOperator", payload) =>
    post(source, "RegisterShipment", payload),

  completeExecution: (source = "SolarentOperator", payload) =>
    post(source, "CompleteExecution", payload),

  revertStage: (source = "SolarentOperator", requestId) =>
    post(source, "RevertStage", { requestId }),
};

export default FulfillmentWorkQueueApi;
